<div class="header-box">
  <div class="d-flex align-items-center heading-box">
    <ng-icon name="heroBellAlert"></ng-icon>
    <div>
      <h2 *ngIf="mode">
        <small>{{ mode + " Notification" | titlecase }}</small>
      </h2>
      <h2 *ngIf="formLoading; else loaded">
        <ngx-skeleton-loader [theme]="{ height: '20px', width: '200px' }"></ngx-skeleton-loader>
      </h2>
      <ng-template #loaded>
        <h2>{{ id ? notificationForm.get('notificationName').value: "Add notification" }}</h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <button color="accent" mat-raised-button *ngIf="userService.permissionsValue['_CLAUSES_EDIT_'] && mode == 'view'"
      [routerLink]="['/app/notification', 'edit', id]">
      Edit Notification
    </button>
  </div>
</div>
<div class="inner-box">
  <mat-card class="without-expansion">
    <mat-card-content class="form-head">
      <div *ngIf="formLoading; else show">
        <ngx-skeleton-loader [theme]="{ height: '80px', width: '70%', margin: '0 auto'}"></ngx-skeleton-loader>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-5">
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '50px', width: '30px', opacity: '0', float: 'right', visibility: 'hidden'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
        </div>
      </div>
      <ng-template #show>
        <form [formGroup]="notificationForm" (ngSubmit)="saveNotification()">
          <div class="col-md-12 d-flex p-0">
            <div class="col-md-3">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Notification Name</mat-label>
                  <input matInput formControlName="notificationName" type="text" autocomplete="off"
                    [errorStateMatcher]="matcher" />
                  <mat-error *ngIf="notificationForm.get('notificationName')?.hasError('required')">
                    Notification Name is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-3">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Notification Type</mat-label>
                  <mat-select formControlName="notificationType">
                    <mat-option *ngFor="let option of notificationTypes" [value]="option">{{ option }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="notificationForm.get('notificationType')?.hasError('required')">
                    Notification Type is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-3">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Select Contract Type</mat-label>
                  <input type="text" matInput [matAutocomplete]="auto" formControlName="contractTypeName"
                    (input)="onInputChange($event.target.value)" #contractInput [errorStateMatcher]="matcher">
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
                    <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                      {{option.name}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="notificationForm.get('contractTypeName').hasError('required')">
                    Contract Type is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-3">
              <div class="dense-2 ">
                <mat-form-field appearance="outline">
                  <mat-label>Trigger (Action / Event)</mat-label>
                  <mat-select formControlName="actionId" [errorStateMatcher]="matcher">
                    <mat-option *ngFor="let trigger of notificationTriggers" [value]="trigger.actionId">{{
                      trigger.actionName }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="notificationForm.get('actionId').hasError('required')">
                    Notification Trigger is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 d-flex p-0">
            <div [ngClass]="mode != 'view' ? 'w-75' : 'w-100'">
              <div class="row px-3">
                <div class="col-md-6">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Send Email To</mat-label>
                      <mat-select formControlName="sendEmailTo" [errorStateMatcher]="matcher" multiple="true">
                        <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.contractRole }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="notificationForm.get('sendEmailTo').hasError('required')">
                        Send Email To is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Send CC's To</mat-label>
                      <mat-select formControlName="ccEmailTo" [errorStateMatcher]="matcher" multiple="true">
                        <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.contractRole }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="notificationForm.get('ccEmailTo').hasError('required')">
                        CC Email To is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="notificationForm.get('sendEmailTo').value?.includes(1)">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Select Send Users</mat-label>
                      <mat-select formControlName="users" [errorStateMatcher]="matcher" multiple="true">
                        <mat-option *ngFor="let user of users" [value]="user.id">{{ user.firstName + (user.middleName ?
                          ' ' + user.middleName + ' ' : ' ') + user.lastName }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="notificationForm.get('users').hasError('required')">
                        Send To users is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="notificationForm.get('ccEmailTo').value?.includes(1)">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Select CC Users</mat-label>
                      <mat-select formControlName="ccUsers" [errorStateMatcher]="matcher" multiple="true">
                        <mat-option *ngFor="let user of users" [value]="user.id">{{ user.firstName + (user.middleName ?
                          ' ' + user.middleName + ' ' : ' ') + user.lastName }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="notificationForm.get('ccUsers').hasError('required')">
                        CC users is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Subject</mat-label>
                    <input matInput formControlName="emailSubject" type="text" autocomplete="off"
                      [errorStateMatcher]="matcher" />
                    <mat-error *ngIf="notificationForm.get('emailSubject')?.hasError('required')">
                      Subject is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-12">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <div class="editor-container">
                      <angular-editor formControlName="emailBody" #emailBodyTextarea [config]="editorConfig"
                        placeholder="Email Body"></angular-editor>
                    </div>
                    <input matInput style="display: none;" formControlName="emailBody">
                    <mat-error *ngIf="notificationForm.get('emailBody')?.hasError('required')">
                      Email Body is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="w-25 pl-2" *ngIf="mode != 'view'">
              <h4>Select Metadata to insert in Email</h4>
              <div class="meta-box">
                <div *ngFor="let meta of metaData">
                  <h5 (click)="insertMeta(meta)">{{ meta }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 d-flex p-0 justify-content-end mt-3" *ngIf="mode != 'view'">
            <button color="primary  " class="outlined-btn" mat-raised-button (click)="reset()" type="reset"
              [disabled]="isLoading">Reset</button>
            <button color="accent" mat-raised-button type="submit" class="ml-3" [disabled]="isLoading">{{ id
              ? 'Update' : 'Save' }}
              <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
            </button>
          </div>
        </form>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>